import ChangePassowrd from "./Others/ChangePassowrd";
import Dashboard from "./SidetabPages/Dashboard/Dashboard";
import EditProfile from "./Others/EditProfile";
import ForgetPassword from "./AccountsPage/ForgetPassword";
import Login from "./AccountsPage/Login";
import AuthLayout from "../layout/authLayout";
import Customer from "./SidetabPages/Customer/Customer";
import AddCustomer from "./SidetabPages/Customer/AddCustomer";
import CustomerProfile from "./SidetabPages/Customer/CustomerProfile";
import EditAddress from "./SidetabPages/Customer/EditAddress";
import ServiceProvider from "./SidetabPages/ServiceProvider/ServiceProvider";
import AddServiceProvider from "./SidetabPages/ServiceProvider/AddServiceProvider";
import ServiceProviderProfile from "./SidetabPages/ServiceProvider/ServiceProviderProfile";
import Services from "./SidetabPages/Catalog/Services/Services";
import AddOn from "./SidetabPages/Catalog/AddOn/AddOn";
import EditAddOn from "./SidetabPages/Catalog/AddOn/EditAddOn";
import AddService from "./SidetabPages/Catalog/Services/AddService";
import Booking from "./SidetabPages/Booking/Booking";
import BookingDetailView from "./SidetabPages/Booking/BookingDetail";
import Offers from "./SidetabPages/Offers/Offers";
import AddOffer from "./SidetabPages/Offers/AddOffer";
import OrderReport from "./SidetabPages/Reports/Orders/OrderReport";
import CustomerReport from "./SidetabPages/Reports/Customers/CustomerReport";
import AdminTransaction from "./SidetabPages/Transaction/AdminTransaction/AdminTransaction";
import WithdrawalTransaction from "./SidetabPages/Transaction/WithdrawalTransaction/WithdrawalTransaction";
import FAQ from "./SidetabPages/Configuration/FAQs/FAQ";
import ContentPage from "./SidetabPages/Configuration/ContentPage/ContentPage";
import AddFaq from "./SidetabPages/Configuration/FAQs/AddFaq";
import EditContentPage from "./SidetabPages/Configuration/ContentPage/EditContentPage";
import BasicSetting from "./SidetabPages/Configuration/BasicSetting/BasicSetting";
import InstallationSetting from "./SidetabPages/Configuration/InstallationSetting/InstallationSetting";
import MailTemplate from "./SidetabPages/Configuration/MailTemplate/MailTemplate";
import SMSTemplate from "./SidetabPages/Configuration/SMSTemplate/SMSTemplate";
import AddVehicleMake from "./SidetabPages/Catalog/VehicleMake/AddVehicleMake";
import VehicleMakes from "./SidetabPages/Catalog/VehicleMake/VehicleMakes";
import AddVehicleModel from "./SidetabPages/Catalog/VehicleModel/AddVehicleModel";
import VehicleModels from "./SidetabPages/Catalog/VehicleModel/VehicleModels";
import ServiceDetailView from "./SidetabPages/ServiceProvider/ServiceDetailView";
import DocumentIndex from "../components/SidetabPages/Documents/DocumentIndex";
import Documents from "./SidetabPages/Documents/Documents";
import AddDocument from "./SidetabPages/Documents/AddDocument";
import DocumentProfile from "./SidetabPages/Documents/DocumentProfile";
import SendMailIndex from "../components/SidetabPages/Customers/SendMailIndex";
import Category from "./SidetabPages/TemplateCategory/Category";
import AddCategory from "./SidetabPages/TemplateCategory/AddCategory";
import ViewAddress from "./SidetabPages/Customer/ViewAddress";
import EmailSignature from "./SidetabPages/EmailSignature/EmaiSignature";
import SendTextIndex from "../components/SidetabPages/Customers/SendTextIndex";
import ContactMessageIndex from "../components/SidetabPages/ContactMessages/ContactMessageIndex";
import ViewMessageIndex from "../components/SidetabPages/ContactMessages/ViewMessageIndex";
import SubscribersIndex from "../components/SidetabPages/Subscribers/SubscribersIndex";
import ViewSubscribersIndex from "../components/SidetabPages/Subscribers/ViewSubscribersIndex";
import DetailSettingsIndex from "../components/SidetabPages/DetailSettings/DetailSettings";
import FacebookMessageIndex from "../components/SidetabPages/FacebookMessages/FacebookMessageIndex";
import ViewFacebookMessageIndex from "../components/SidetabPages/FacebookMessages/ViewFacebookMessageIndex";
import InstagramMessageIndex from "../components/SidetabPages/InstagramMessages/InstagramMessageIndex";
import ViewInstagramMessageIndex from "../components/SidetabPages/InstagramMessages/ViewInstagramMessageIndex";
import TwitterMessageIndex from "../components/SidetabPages/TwitterMessages/TwitterMessageIndex";
import ViewTwitterMessageIndex from "../components/SidetabPages/TwitterMessages/ViewTwitterMessageIndex";
import YoutubeMessageIndex from "../components/SidetabPages/YoutubeMessages/YoutubeMessageIndex";
import ViewYoutubeMessageIndex from "../components/SidetabPages/YoutubeMessages/ViewYoutubeMessageIndex";
import ViewTiktokMessageIndex from "../components/SidetabPages/TiktokMessages/ViewTiktokMessageIndex";
import TiktokMessageIndex from "../components/SidetabPages/TiktokMessages/TiktokMessageIndex";
import OnlineFormIndex from "../components/SidetabPages/OnlineForms/OnlineFormIndex";
import ViewOnlineFormIndex from "../components/SidetabPages/OnlineForms/ViewOnlineFormIndex";
import FinanceFormIndex from "../components/SidetabPages/FinanceForm/FinanceFormIndex";
import ViewFinanceFormIndex from "../components/SidetabPages/FinanceForm/ViewFinanceFormIndex";
import FinancialForm from "../components/SidetabPages/FinanceForm/financialFormEdit";
import SubAdminIndex from "../components/SidetabPages/SubAdmin/SubAdminIndex";
import AddSubAdminIndex from "../components/SidetabPages/SubAdmin/AddSubAdminIndex";
import ViewSubAdminProfile from "../components/SidetabPages/SubAdmin/ViewSubAdminProfile";
import CreatePass from "./AccountsPage/CreatePass/createPass";
import FinanceConfigure from "../components/SidetabPages/FinanceForm/FinanceConfigure";
import SMSIndex from "../components/SidetabPages/Catalog/smsServices/smsIndex";
import AddSMSIndex from "../components/SidetabPages/Catalog/smsServices/AddSMSIndex";
import RoleIndex from "../components/SidetabPages/RoleAndPermissions/RoleIndex";
import AddRoleIndex from "../components/SidetabPages/RoleAndPermissions/AddRoleIndex";
import DocCategoryIndex from "../components/SidetabPages/DocumentCategory/CategoryIndex";
import AddDocCategoryIndex from "../components/SidetabPages/DocumentCategory/AddCategoryIndex";
import GenerateCode from "../components/GenerateCode/generateCode";
import LandingPage from "./AccountsPage/Landing";
import LandingPages from "./AccountsPage/LandingPages";
import HealthIndex from "../components/SidetabPages/Insurance/HealthInsurance/HealthIndex";
import ViewHealthIndex from "../components/SidetabPages/Insurance/HealthInsurance/ViewHealthIndex";
import ResetPass from "../components/SidetabPages/Customers/ResetPass";
import AssignClient from "../components/SidetabPages/Customers/AssignClient";
import AddEditNoteIndex from "../components/SidetabPages/Customers/notes/AddEditNotes";
import NotesIndex from "../components/SidetabPages/Customers/notes/NotesIndex";
import SubadminResetPass from "../components/SidetabPages/SubAdmin/ResetPass";
import AddCallerClientIndex from "../components/SidetabPages/Customers/AddCallerClientIndex";
import SMSHistory from "../components/SidetabPages/Customers/SMSHistory";
import DraftEmailIndex from "../components/SidetabPages/Customers/DraftEmailIndex";

const authRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/",
    component: <LandingPage />,
  },
  {
    path: "/forgetpassword",
    component: <ForgetPassword />,
  },
  {
    path: "/create-password",
    component: <CreatePass />,
  },
];
const routes = [
  {
    path: "/dashboard",
    component: (
      <AuthLayout>
        <Dashboard />
      </AuthLayout>
    ),
  },
  {
    path: "/edit-profile",
    component: (
      <AuthLayout>
        <EditProfile />
      </AuthLayout>
    ),
  },
  {
    path: "/change-password",
    component: (
      <AuthLayout>
        <ChangePassowrd />
      </AuthLayout>
    ),
  },
  {
    path: "/customers",
    component: (
      <AuthLayout>
        <Customer />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/add",
    component: (
      <AuthLayout>
        <AddCustomer />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/edit/:editId",
    component: (
      <AuthLayout>
        <AddCustomer />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/mail/:editId",
    component: (
      <AuthLayout>
        <SendMailIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/customers/detail/mail/:editId",
    component: (
      <AuthLayout>
        <SendMailIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/customers/mail/:editId/:mailId",
    component: (
      <AuthLayout>
        <SendMailIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/customers/notes/add/:editId",
    component: (
      <AuthLayout>
        <AddEditNoteIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/customers/sms-history/:editId",
    component: (
      <AuthLayout>
        <SMSHistory />
      </AuthLayout>
    ),
  },

  {
    path: "/customers/draft-email/:editId",
    component: (
      <AuthLayout>
        <DraftEmailIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/notes/edit/:editId/:noteId",
    component: (
      <AuthLayout>
        <AddEditNoteIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/notes/:editId",
    component: (
      <AuthLayout>
        <NotesIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/subscriber/mail/:type/:editId",
    component: (
      <AuthLayout>
        <SendMailIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/sms/:editId",
    component: (
      <AuthLayout>
        <SendTextIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/detail/sms/:editId",
    component: (
      <AuthLayout>
        <SendTextIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/reset-password/:editId",
    component: (
      <AuthLayout>
        <ResetPass />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/assign/:editId",
    component: (
      <AuthLayout>
        <AssignClient />
      </AuthLayout>
    ),
  },
  {
    path: "/subscriber/sms/:type/:editId",
    component: (
      <AuthLayout>
        <SendTextIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/profile/:editId",
    component: (
      <AuthLayout>
        <CustomerProfile />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/document/upload/:userId/:docId",
    component: (
      <AuthLayout>
        <EditAddress />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/document/view/:userId/:docId",
    component: (
      <AuthLayout>
        <ViewAddress />
      </AuthLayout>
    ),
  },

  {
    path: "/contact-messages",
    component: (
      <AuthLayout>
        <ContactMessageIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/facebook-messages",
    component: (
      <AuthLayout>
        <FacebookMessageIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/instagram-messages",
    component: (
      <AuthLayout>
        <InstagramMessageIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/twitter-messages",
    component: (
      <AuthLayout>
        <TwitterMessageIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/youtube-messages",
    component: (
      <AuthLayout>
        <YoutubeMessageIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/tiktok-messages",
    component: (
      <AuthLayout>
        <TiktokMessageIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/contact-messages/detail/:editId",
    component: (
      <AuthLayout>
        <ViewMessageIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/facebook-messages/detail/:editId",
    component: (
      <AuthLayout>
        <ViewFacebookMessageIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/instagram-messages/detail/:editId",
    component: (
      <AuthLayout>
        <ViewInstagramMessageIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/twitter-messages/detail/:editId",
    component: (
      <AuthLayout>
        <ViewTwitterMessageIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/youtube-messages/detail/:editId",
    component: (
      <AuthLayout>
        <ViewYoutubeMessageIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/tiktok-messages/detail/:editId",
    component: (
      <AuthLayout>
        <ViewTiktokMessageIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/subscribers",
    component: (
      <AuthLayout>
        <SubscribersIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/subscribers/detail/:editId",
    component: (
      <AuthLayout>
        <ViewSubscribersIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/online-forms",
    component: (
      <AuthLayout>
        <OnlineFormIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/online-forms/detail/:editId",
    component: (
      <AuthLayout>
        <ViewOnlineFormIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/finance-form",
    component: (
      <AuthLayout>
        <FinanceFormIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/finance-configure",
    component: (
      <AuthLayout>
        <FinanceConfigure />
      </AuthLayout>
    ),
  },
  {
    path: "/finance-form/detail/:editId",
    component: (
      <AuthLayout>
        <ViewFinanceFormIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/finance-form/edit/:editId",
    component: (
      <AuthLayout>
        <FinancialForm />
      </AuthLayout>
    ),
  },
  {
    path: "/temp-categories",
    component: (
      <AuthLayout>
        <Category />
      </AuthLayout>
    ),
  },
  {
    path: "/temp-categories/add",
    component: (
      <AuthLayout>
        <AddCategory />
      </AuthLayout>
    ),
  },
  {
    path: "/temp-categories/edit/:editId",
    component: (
      <AuthLayout>
        <AddCategory />
      </AuthLayout>
    ),
  },

  {
    path: "/doc-categories",
    component: (
      <AuthLayout>
        <DocCategoryIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/doc-categories/add",
    component: (
      <AuthLayout>
        <AddDocCategoryIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/doc-categories/edit/:editId",
    component: (
      <AuthLayout>
        <AddDocCategoryIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/documents",
    component: (
      <AuthLayout>
        <Documents />
      </AuthLayout>
    ),
  },
  {
    path: "/documents/add",
    component: (
      <AuthLayout>
        <AddDocument />
      </AuthLayout>
    ),
  },
  {
    path: "/documents/edit/:editId",
    component: (
      <AuthLayout>
        <AddDocument />
      </AuthLayout>
    ),
  },
  {
    path: "/documents/profile/:editId",
    component: (
      <AuthLayout>
        <DocumentProfile />
      </AuthLayout>
    ),
  },
  {
    path: "/generate-code",
    component: (
      <AuthLayout>
        <GenerateCode />
      </AuthLayout>
    ),
  },
  {
    path: "/landing-pages",
    component: (
      <AuthLayout>
        <LandingPages />
      </AuthLayout>
    ),
  },
  {
    path: "/subadmins",
    component: (
      <AuthLayout>
        <SubAdminIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/subadmins/add",
    component: (
      <AuthLayout>
        <AddSubAdminIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/subadmins/edit/:editId",
    component: (
      <AuthLayout>
        <AddSubAdminIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/subadmins/reset-password/:editId",
    component: (
      <AuthLayout>
        <SubadminResetPass />
      </AuthLayout>
    ),
  },
  {
    path: "/subadmins/profile/:editId",
    component: (
      <AuthLayout>
        <ViewSubAdminProfile />
      </AuthLayout>
    ),
  },
  {
    path: "/customers/caller-clients/add",
    component: (
      <AuthLayout>
        <AddCallerClientIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/role-permissions",
    component: (
      <AuthLayout>
        <RoleIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/role-permissions/add",
    component: (
      <AuthLayout>
        <AddRoleIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/role-permissions/edit/:editId",
    component: (
      <AuthLayout>
        <AddRoleIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/documents/address/edit/:_id",
    component: (
      <AuthLayout>
        <EditAddress />
      </AuthLayout>
    ),
  },
  {
    path: "/templates",
    component: (
      <AuthLayout>
        <ServiceProvider />
      </AuthLayout>
    ),
  },
  {
    path: "/templates/add",
    component: (
      <AuthLayout>
        <AddServiceProvider />
      </AuthLayout>
    ),
  },
  {
    path: "/templates/edit/:editId",
    component: (
      <AuthLayout>
        <AddServiceProvider />
      </AuthLayout>
    ),
  },
  {
    path: "/templates/profile/:editId",
    component: (
      <AuthLayout>
        <ServiceProviderProfile />
      </AuthLayout>
    ),
  },
  {
    path: "/templates/service/:_id",
    component: (
      <AuthLayout>
        <ServiceDetailView />
      </AuthLayout>
    ),
  },
  {
    path: "/email-templates",
    component: (
      <AuthLayout>
        <Services />
      </AuthLayout>
    ),
  },
  {
    path: "/email-templates/add",
    component: (
      <AuthLayout>
        <AddService />
      </AuthLayout>
    ),
  },
  {
    path: "/email-templates/edit/:editId",
    component: (
      <AuthLayout>
        <AddService />
      </AuthLayout>
    ),
  },

  {
    path: "/sms-templates",
    component: (
      <AuthLayout>
        <SMSIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/sms-templates/add",
    component: (
      <AuthLayout>
        <AddSMSIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/sms-templates/edit/:editId",
    component: (
      <AuthLayout>
        <AddSMSIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/document-templates",
    component: (
      <AuthLayout>
        <Services />
      </AuthLayout>
    ),
  },

  {
    path: "/health-insurance",
    component: (
      <AuthLayout>
        <HealthIndex />
      </AuthLayout>
    ),
  },
  {
    path: "/health-insurance/detail/:editId",
    component: (
      <AuthLayout>
        <ViewHealthIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/catalog/add-on",
    component: (
      <AuthLayout>
        <AddOn />
      </AuthLayout>
    ),
  },
  {
    path: "/catalog/add-on/add",
    component: (
      <AuthLayout>
        <EditAddOn />
      </AuthLayout>
    ),
  },
  {
    path: "/catalog/add-on/edit/:_id",
    component: (
      <AuthLayout>
        <EditAddOn />
      </AuthLayout>
    ),
  },
  {
    path: "/catalog/services/add",
    component: (
      <AuthLayout>
        <AddService />
      </AuthLayout>
    ),
  },
  {
    path: "/catalog/services/edit/:_id",
    component: (
      <AuthLayout>
        <AddService />
      </AuthLayout>
    ),
  },
  {
    path: "/catalog/vehicle-makes",
    component: (
      <AuthLayout>
        <VehicleMakes />
      </AuthLayout>
    ),
  },
  {
    path: "/catalog/vehicle-makes/add",
    component: (
      <AuthLayout>
        <AddVehicleMake />
      </AuthLayout>
    ),
  },
  {
    path: "/catalog/vehicle-makes/edit/:_id",
    component: (
      <AuthLayout>
        <AddVehicleMake />
      </AuthLayout>
    ),
  },
  {
    path: "/catalog/vehicle-models",
    component: (
      <AuthLayout>
        <VehicleModels />
      </AuthLayout>
    ),
  },
  {
    path: "/catalog/vehicle-models/add",
    component: (
      <AuthLayout>
        <AddVehicleModel />
      </AuthLayout>
    ),
  },
  {
    path: "/catalog/vehicle-models/edit/:editId",
    component: (
      <AuthLayout>
        <AddVehicleModel />
      </AuthLayout>
    ),
  },
  {
    path: "/bookings",
    component: (
      <AuthLayout>
        <Booking />
      </AuthLayout>
    ),
  },
  {
    path: "/bookings/booking-detail/:_id",
    component: (
      <AuthLayout>
        <BookingDetailView />
      </AuthLayout>
    ),
  },
  {
    path: "/offers",
    component: (
      <AuthLayout>
        <Offers />
      </AuthLayout>
    ),
  },
  {
    path: "/offers/add",
    component: (
      <AuthLayout>
        <AddOffer />
      </AuthLayout>
    ),
  },
  {
    path: "/report/bookings",
    component: (
      <AuthLayout>
        <OrderReport />
      </AuthLayout>
    ),
  },
  {
    path: "/report/customers",
    component: (
      <AuthLayout>
        <CustomerReport />
      </AuthLayout>
    ),
  },
  {
    path: "/accounting/admin",
    component: (
      <AuthLayout>
        <AdminTransaction />
      </AuthLayout>
    ),
  },
  {
    path: "/accounting/withdrawal",
    component: (
      <AuthLayout>
        <WithdrawalTransaction />
      </AuthLayout>
    ),
  },

  {
    path: "/configuration/faq",
    component: (
      <AuthLayout>
        <FAQ />
      </AuthLayout>
    ),
  },
  {
    path: "/configuration/faq/add",
    component: (
      <AuthLayout>
        <AddFaq />
      </AuthLayout>
    ),
  },
  {
    path: "/configuration/faq/edit/:editId",
    component: (
      <AuthLayout>
        <AddFaq />
      </AuthLayout>
    ),
  },
  {
    path: "/configuration/contentpage",
    component: (
      <AuthLayout>
        <ContentPage />
      </AuthLayout>
    ),
  },
  {
    path: "/configuration/contentpage/edit/:editId",
    component: (
      <AuthLayout>
        <EditContentPage />
      </AuthLayout>
    ),
  },
  {
    path: "/notification-settings",
    component: (
      <AuthLayout>
        <BasicSetting />
      </AuthLayout>
    ),
  },

  {
    path: "/basic-settings",
    component: (
      <AuthLayout>
        <DetailSettingsIndex />
      </AuthLayout>
    ),
  },

  {
    path: "/email-signature",
    component: (
      <AuthLayout>
        <EmailSignature />
      </AuthLayout>
    ),
  },
  {
    path: "/configuration/installation-setting",
    component: (
      <AuthLayout>
        <InstallationSetting />
      </AuthLayout>
    ),
  },
  {
    path: "/configuration/smstemplate",
    component: (
      <AuthLayout>
        <SMSTemplate />
      </AuthLayout>
    ),
  },
];

export { routes, authRoutes };
